import { createI18n } from 'vue-i18n'
import type { App } from 'vue'
import { useStorage } from '@/hooks/system/useStorage'
import { ELangTransform } from '@/enums/langEnum'
import { EGlobalConfig } from '@/enums/cacheEnum'
import { useLangApi, useLangDB } from '@/api/lang/hooks'
import { isEmpty } from '@/utils/is'

const JSON = import.meta.glob('./lang/**/*.json')

/** lang 目录下的所有 key 示例: ['zh', 'en', 'jp'] */
export const messages = []
for (const key in JSON) {
  // const KEY = key.replace(/.\/lang\//, '').replace(/.json/, '')
  const match = key.match(/(?<=\.\/lang\/)([^\/]+)(?=\/)/)
  if (match) {
    const KEY = match[0]
    const msgFind = messages.find(e => e.name === KEY)

    const path = key
    if (!msgFind) {
      messages.push({
        key: ELangTransform[KEY],
        name: KEY,
        children: [path],
      })
    } else {
      msgFind.children.push(path)
    }
  }
}

export async function loadLangJSON(name) {
  const lang = messages.find(e => e.key === name)

  const langJSON = await Promise.all([
    import(`./lang/${lang.name}/index.json`),
    import(`./lang/${lang.name}/pages.json`),
  ])

  const langMap = {}
  langJSON.forEach((e) => {
    Object.assign(langMap, e.default)
  })

  return langMap
}

/** 获取当前语言 */
export const getCurrentLang = (): string => useStorage.ls.get(EGlobalConfig.language) || 'ENG'

/** 欧美语言 */
export const isOuLang = computed(() => {
  return isOu(getCurrentLang())
})

export function isOuApi() {
  return isOu(getCurrentLang())
}

export function isOu(lang) {
  return ['HIN', 'TR', 'SAU', 'ENG', 'DEU', 'SPA', 'FRA', 'BRA', 'RUS'].includes(lang)
}

const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式，则需要将其设置为false
  globalInjection: true, // 全局生效$t
  locale: '', // 默认cn翻译
  messages: {},
  missing() {
    return ''
  },
})

export default i18n

/** 懒加载语言json, 只有在切换语言时才会 加载json */
export async function importLocLang(langKey: string) {
  if (langKey === 'ZHO') langKey = 'CMN'
  if (!['CMN', 'ENG', 'VIE'].includes(langKey)) langKey = 'ENG'
  // 优先读取本地数据
  const langDB = await useLangDB(langKey)
  i18n.global.setLocaleMessage(langKey, langDB)
  if (!isEmpty(langDB)) i18n.global.locale.value = langKey

  // 读取默认文件
  // const keyFind = messages.find(e => e.key === langKey)
  loadLangJSON(langKey).then(async (lang) => {
    // const lang = (await import(`./lang/${keyFind.name || 'zh'}.json`)).default
    i18n.global.mergeLocaleMessage(langKey, lang)
    i18n.global.locale.value = langKey

    // 继续从服务端读取，更新最新数据
    const langApi = await useLangApi(langKey, lang)
    i18n.global.mergeLocaleMessage(langKey, langApi)
  })
}

export function mergeLocaleMessage(lang) {
  const langNow = i18n.global.getLocaleMessage(getCurrentLang())
  i18n.global.setLocaleMessage(getCurrentLang(), { ...langNow, ...lang })
}

export async function installI18n(app: App) {
  app.use(i18n)
  await importLocLang(getCurrentLang())
}
